import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './Support.css';

const Support: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'contact' | 'faq'>('contact');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const faqItems = [
    {
      question: 'How do I enroll in a course?',
      answer: 'You can enroll in a course by clicking the "Enroll" button on the course details page. For paid courses, you can pay online or upload a payment receipt.'
    },
    {
      question: 'How do I access my enrolled courses?',
      answer: 'Go to "My Courses" from the bottom navigation or your profile. All your enrolled courses will be listed there.'
    },
    {
      question: 'Can I download course videos?',
      answer: 'No, course videos are protected and cannot be downloaded. They are only available for streaming within the app.'
    },
    {
      question: 'How do I reset my password?',
      answer: 'Go to the login page and click "Forgot password". Enter your email or phone number and follow the instructions.'
    },
    {
      question: 'What payment methods are accepted?',
      answer: 'We accept online payments via credit/debit cards, Apple Pay, and PayPal. You can also upload a payment receipt for bank transfers.'
    }
  ];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Submit contact form logic
    console.log('Submitting support request', formData);
    alert('Your message has been sent. We will get back to you soon!');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="support-page">
      <header className="support-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ←
        </button>
        <h1>Support</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="support-content">
        {/* Tabs */}
        <div className="support-tabs">
          <button
            className={`support-tab ${activeTab === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveTab('contact')}
          >
            Contact Us
          </button>
          <button
            className={`support-tab ${activeTab === 'faq' ? 'active' : ''}`}
            onClick={() => setActiveTab('faq')}
          >
            FAQ
          </button>
        </div>

        {/* Contact Form */}
        {activeTab === 'contact' && (
          <div className="contact-section">
            <div className="contact-info-card">
              <h3>Get in Touch</h3>
              <div className="contact-methods">
                <div className="contact-method">
                  <span className="method-icon">📧</span>
                  <div className="method-info">
                    <span className="method-label">Email</span>
                    <span className="method-value">support@sparkademy.com</span>
                  </div>
                </div>
                <div className="contact-method">
                  <span className="method-icon">📞</span>
                  <div className="method-info">
                    <span className="method-label">Phone</span>
                    <span className="method-value">+961 70 123 456</span>
                  </div>
                </div>
                <div className="contact-method">
                  <span className="method-icon">🕐</span>
                  <div className="method-info">
                    <span className="method-label">Hours</span>
                    <span className="method-value">Mon-Fri: 9 AM - 6 PM</span>
                  </div>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Subject</label>
                <input
                  type="text"
                  placeholder="What is this regarding?"
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  placeholder="Describe your issue or question..."
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows={6}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>
        )}

        {/* FAQ Section */}
        {activeTab === 'faq' && (
          <div className="faq-section">
            {faqItems.map((item, index) => (
              <div key={index} className="faq-item">
                <h3 className="faq-question">{item.question}</h3>
                <p className="faq-answer">{item.answer}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Support;
